export default __webpack_public_path__ + "static/media/box-arrow-white.e9229b36.svg";